import React from "react";
import PropTypes from "prop-types";
import { H4 } from "components/core/Typography";
import { DropdownItem } from "components/molecules";
import { SectionHeading } from "components/atoms";
import ChevronRightSvg from "assets/images/slp/chevron-right.svg";
import AmenitiesIconSvg from "assets/images/slp/amenities-icon.svg";
import { storageMap } from "./storageMap";
import "./CitySection.scss";

function DrilldownLinks({ items, name }) {
  return (
    <div className="slp-accordion-links">
      {items.map((item) => {
        const matched = storageMap.find((t) => item?.text?.includes(t.key));
        const result = matched ? `${matched.label} in ${name}` : item?.text;
        return (
          <a key={item.uri} href={`/${item.uri}`} className="slp-accordion-links__item">
            <H4 className="slp-accordion-links__text" size="small">{result}</H4>
            <img src={ChevronRightSvg} className="slp-accordion-links__chevron" alt="" aria-hidden="true" />
          </a>
        );
      })}
    </div>
  );
}

DrilldownLinks.propTypes = {
  name: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    uri: PropTypes.string.isRequired
  })).isRequired
};

export default function CitySection({ city }) {
  const { name, url, links } = city;

  return (
    <div className="slp-city-section">
      <SectionHeading level="2" withUnderline>
        {name} Storage Units
      </SectionHeading>

      <div className="slp-city-section__dropdowns">
        {(links?.amenities?.length > 0) && (
          <DropdownItem icon={<img src={AmenitiesIconSvg} alt="" aria-hidden="true" />} label="Storage Unit Amenities">
            <DrilldownLinks items={links.amenities} name={name} />
          </DropdownItem>
        )}
      </div>

      <a href={url} className="slp-city-section__cta">
        View all storage units in {name}
      </a>
    </div>
  );
}

CitySection.propTypes = {
  city: PropTypes.shape({
    name: PropTypes.string.isRequired,

    url: PropTypes.string,
    links: PropTypes.shape({
      amenities: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, uri: PropTypes.string }))
    })
  }).isRequired
};
